var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.683 2.84999L17.15 0.316988C16.9941 0.160801 16.7942 0.0561046 16.577 0.016988C16.4159 -0.0122412 16.2503 -0.00466656 16.0925 0.0391454C15.9348 0.0829573 15.789 0.161872 15.666 0.269988C15.6489 0.285129 15.6322 0.300803 15.616 0.316988L13.63 2.30199L17.698 6.36999L19.683 4.38499C19.8778 4.18964 19.9911 3.92753 19.9998 3.65177C20.0085 3.37602 19.9121 3.10726 19.73 2.89999C19.7149 2.8825 19.6992 2.86549 19.683 2.84899V2.84999Z",
    fill: "#3EA754"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.933V20H4.067L16.07 7.998L12.003 3.931L0 15.933Z",
    fill: "#3EA754"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.064a5e2c66c1e6587a4f233696360dcd.svg";
export { ForwardRef as ReactComponent };